/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { withRouter, Navigate, useParams } from 'react-router-dom';
import jwt from 'jwt-decode'
import Axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
// import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/styles';
import {
  Grid,
  Button,
  IconButton,
  TextField,
  Typography
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Backdrop from '@material-ui/core/Backdrop';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import MuiAlert from '@material-ui/lab/Alert';
import ROUTE from '../../utils';
import { fakeAuth } from '../authServices/privateRoute'
import { Signature, Encryption } from '../../utils/index'
import { Base64 } from 'js-base64';
// import { Facebook as FacebookIcon, Google as GoogleIcon } from '../../icons';

function Alert(props) {
  return <MuiAlert elevation={0} variant="filled" {...props} />;
}

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    // email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  }
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%'
  },
  grid: {
    height: '100%'
  },
  quoteContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  quote: {
    backgroundColor: theme.palette.neutral,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/auth.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px'
  },
  quoteText: {
    color: theme.palette.white,
    fontWeight: 300
  },
  name: {
    marginTop: theme.spacing(3),
    color: theme.palette.white
  },
  bio: {
    color: theme.palette.white
  },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  logoImage: {
    marginLeft: theme.spacing(4)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  socialButtons: {
    marginTop: theme.spacing(3)
  },
  socialIcon: {
    marginRight: theme.spacing(1)
  },
  sugestion: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

export const SignIn = props => {
  const { history } = props;

  const classes = useStyles();
  const [redirectToReferrer, setRedirectToReferrer] = useState(false)
  // const [] = useState('')
  const [message, setMessage] = useState('')
  const [openSnack, setOpenSnack] = useState(false);
  const [snackOpenError, setSnackOpenError] = useState(false);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  const Login = (event) => {
    event.preventDefault();
    const { email, password } = formState.values;
    if (Base64.encode(password) === process.env.REACT_APP_LOG && Base64.encode(email) === process.env.REACT_APP_LOM) {
      fakeAuth.authenticate(() => {
        setRedirectToReferrer(true);
      })
    } else {
      setMessage('Unable to Login, Wrong Credentials')
      setTimeout(() => {
        setMessage('')
         }, 3000) 
      }
  }
  // signature work
  const query = "auth";
  const {timestamp, signatureValue } = Signature(query)
  // console.log('my signature>', signatureValue)
  // const truesign = "05fa5604f99a2f4f1fb1e743c6fdf8e6d5d2e0d08b394d0a56d77199152b68c4"
  // console.log('true signat>', truesign)
  // console.log('signature check> +++', signatureValue === truesign)

  const loginConfig = {
    headers: {
      // "signature": "60f99e0b1c88f77c4efbd59784a8e9e827ce13da6ad758b10a02e40b8f3ef8ee",
      "signature": `${signatureValue}`,
      "Content-Type": 'application/json;charset=UTF-8',
      //"Content-Type": 'charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
    }
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    handleToggleSnackBar();
    const { email, password } = formState.values;
    const values= {"username":email, "password":password}

    // const apiUrl = "http://192.72.53.36:9090/KYC/LoginReview";
    // const apiUrl = "https://192.72.53.70/KYC/LoginReview";
    const apiUrl = `${window.location.origin}/api/KYC/LoginReview`;
    // const apiUrl = "/KYC/LoginReview";

    const objValues = {
      "username": "KYCUI-TEST",
      "applicationID": "KYCUI",
      "where": values,
      "action": "LOGIN",
      "decryptCols":["username", "firstname", "lastname", "email", "pf_no"],
      "query": "auth",
      "timestamp":timestamp
    }

    const hashedObjValues = Encryption(JSON.stringify(objValues));
    // console.log('>', hashedObjValues)
    await Axios.post(apiUrl, hashedObjValues, loginConfig).then(res => {
      // console.log('>', res.data)
      if (res.data.response_message === "User Login Successful") {
        res.config.headers={};
        // console.log('>',res.config.headers)
        handleCloseSnackBar()
        fakeAuth.authenticate(() => {
          setRedirectToReferrer(true);
        })
        const { token, ID } = res.data;
        const {exp} =jwt(token);
        localStorage.setItem('value', token);
        localStorage.setItem('number', ID);
        sessionStorage.setItem('token', JSON.stringify(token));
        sessionStorage.setItem('exp', exp);
        handleSignIn()
      } else {
        fakeAuth.authenticate(() => {
          setRedirectToReferrer(false);
        })
        handleCloseSnackBar()
        handleOpenSnackError()
      }
    })
      .catch(() => {
        handleCloseSnackBar()
        handleOpenSnackError();
      });
  }

  const handleOpenSnackError = () => {  
    setSnackOpenError(true)
  }

  const handleCloseSnackError = (e, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpenError(false)
  }

  const handleCloseSnackBar = () => {
    setOpenSnack(false);
  };

  const handleToggleSnackBar = () => {
    setOpenSnack(true);
  };

  const handleBack = () => {
    // history.goBack();
    history.push(ROUTE.login);
  };

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleSignIn = () => {
    // event.preventDefault();
    history.push(ROUTE.home);
  };

  const { from } = props.location.state || { from: { pathname: '/home' } }
  const preventDefault = (event) => event.preventDefault();
  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  // redirectToReferrer === true ?
  //   return (<Redirect to='/' />) 
  //   :
  if (redirectToReferrer === true) {
    return <Navigate to={from} />
  } else {

    return (
      <div className={classes.root}>
        <Grid
          className={classes.grid}
          container
        >
          <Backdrop className={classes.backdrop} open={openSnack}>
        <CircularProgress color="inherit" />
      </Backdrop>
        <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={snackOpenError}
        autoHideDuration={3000}
        onClose={handleCloseSnackError}
        key="topcenter"
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackError}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      >
        <Alert onClose={handleCloseSnackError} severity="warning" className={classes.snackFont}>
          Unable to Login now, Please try again in a few minutes or contact support.
                    </Alert>
      </Snackbar>
          <Grid
            className={classes.quoteContainer}
            item
            lg={5}
          >
            <div className={classes.quote}>
              <div className={classes.quoteInner}>
                <Typography
                  className={classes.quoteText}
                  variant="h1"
                >
                  Welcome to the customer KYC update Portal, Signin to capture the accurate
                  records of the customer
              </Typography>
                <div className={classes.person}>
                  <Typography
                    className={classes.name}
                    variant="body1"
                  >
                    Let's Comply with Bank of Uganda
                </Typography>
                  <Typography
                    className={classes.bio}
                    variant="body2"
                  >
                     <Link href="https://www.postbank.co.ug/" variant="body2" target="_blank" className={classes.bio} >
                      {'https://www.postbank.co.ug/'}
                    </Link>
                    
                </Typography>
                </div>
              </div>
            </div>
          </Grid>
          <Grid
            className={classes.content}
            item
            lg={7}
            xs={12}
          >
            <div className={classes.content}>
              <div className={classes.contentHeader}>
                <IconButton onClick={handleBack}>
                  <ArrowBackIcon />
                </IconButton>
              </div>
              <div className={classes.contentBody}>
                <form
                  className={classes.form}
                  // onSubmit={Login}
                  onSubmit={handleLogin} 
                >
                  <Typography
                    className={classes.title}
                    variant="h2"
                  >
                    Sign in
                </Typography>
                  <Typography
                    align="center"
                    className={classes.sugestion}
                    color="textSecondary"
                    variant="body1"
                  >
                    Login with your Credentials
                </Typography>
                  <TextField
                    className={classes.textField}
                    error={hasError('email')}
                    fullWidth
                    helperText={
                      hasError('email') ? formState.errors.email[0] : null
                    }
                    label="User Name"
                    name="email"
                    onChange={handleChange}
                    type="text"
                    value={formState.values.email || ''}
                    variant="outlined"
                  />
                  <TextField
                    className={classes.textField}
                    error={hasError('password')}
                    fullWidth
                    helperText={
                      hasError('password') ? formState.errors.password[0] : null
                    }
                    label="Password"
                    name="password"
                    onChange={handleChange}
                    type="password"
                    value={formState.values.password || ''}
                    variant="outlined"
                  />
                  <Button
                    className={classes.signInButton}
                    color="primary"
                    disabled={!formState.isValid}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    // onClick={Login}
                    onClick={handleLogin}
                  >
                    Sign in now
                </Button>
                  <Typography
                    color="error"
                    variant="body1"
                  >
                    {message}
                    {/* <Link
                    component={RouterLink}
                    to="/form"
                    variant="h6"
                  >
                    Go to KYC Form
                  </Link> */}
                  </Typography>
                </form>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
};

SignIn.propTypes = {
  history: PropTypes.object
};

export default SignIn;
